export const ADMISSION_RATES_DOCUMENT_ROUTE = "/workflow/rates/:admissionId";
export const ADMIN_RATES_DOCUMENT_ROUTE = "/admin/workflows/:admissionId/rates";
